import { Link } from '@/shared/ui';

import { spacing } from '@/config/ui';
import type { RestrictedAccessPageContent } from '@/entities/auth-access';
import Button from '@/shared/ui/primitives/Button';
import { SupportContact } from '@/shared/ui/primitives/SupportContact';
import Typography from '@/shared/ui/typography/Text';

type RestrictedAccessContentProps = {
  content: RestrictedAccessPageContent;
  onPrimaryActionClick: () => void;
};

export const RestrictedAccessContent = ({
  content,
  onPrimaryActionClick
}: RestrictedAccessContentProps) => (
  <>
    <Typography
      size={32}
      sx={{
        fontWeight: 700,
        lineHeight: 1.15,
        mb: spacing[4]
      }}
    >
      {content.title}
    </Typography>

    <Typography
      size={20}
      sx={{
        color: 'gx.subtext',
        mb: spacing[4]
      }}
    >
      {content.subtitle}
    </Typography>

    <Button
      fullWidth
      size='large'
      sx={{
        width: '100%',
        maxWidth: '480px',
        mb: spacing[4]
      }}
      variant='contained'
      onClick={onPrimaryActionClick}
    >
      {content.primaryActionLabel}
    </Button>

    {content.secondaryLinkLabel && content.secondaryLinkHref && (
      <Link
        className='mb-10 inline-flex text-gx-subtext no-underline underline-offset-[3px] hover:underline'
        href={content.secondaryLinkHref}
        rel='noopener noreferrer'
        target='_blank'
      >
        {content.secondaryLinkLabel}
      </Link>
    )}

    <SupportContact sx={{ color: 'gx.subtext', fontSize: '1rem' }} />
  </>
);
